<template>
    <div class="flex flex-col mx-auto w-11/12">
        <a :alt="episode.title" href="" @click.prevent="playEpisode()">
            <div
                class="episode-image relative w-full flex items-center justify-center"
            >
                <app-image
                    width="310"
                    height="175"
                    :url="episode.poster"
                    class="w-full mb-2 rounded-lg"
                    :alt="episode.title"
                    lazy
                >
                </app-image>

                <div
                    v-if="!$isMobile()"
                    class="play-episode-button absolute hidden"
                >
                    <app-image
                        url="Play.svg"
                        is-local
                        class="w-20"
                        :alt="`Play ${episode.title}`"
                    ></app-image>
                </div>
            </div>
        </a>

        <p class="font-primary text-xl text-white ml-1 truncate">
            {{ episode.title }}
        </p>
    </div>
</template>
<script>
import { mapState } from "vuex";
export default {
    name: "episode",
    props: {
        episodes: {
            type: Array,
            required: true,
            default: () => []
        },

        episode: {
            type: Object,
            required: true
        },

        index: {
            type: Number,
            required: true
        }
    },
    data() {
        return {};
    },

    computed: {
        ...mapState(["authenticatedUser", "authenticatedUserAccess"])
    },
    methods: {
        playEpisode: function() {
            if (this.episode.locked) {
                if (!this.authenticatedUser) {
                    this.$router.push({ name: "login" });
                } else if (this.authenticatedUserAccess != "full") {
                    this.$router.push({ name: "register-payment" });
                }
            } else {
                this.$store.dispatch("OPEN_PLAYER", {
                    videos: this.episodes,
                    currentVideo: this.index
                });
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.episode-image:hover .play-episode-button {
    display: block;
}
</style>
